
function MarginTopDatasourceToClassName(datasource_value) {
  switch(datasource_value) {
    case "none":
      return ""
    default:
      return "article-panel-margin-top-normal"
  }
}
function MarginBottomDatasourceToClassName(datasource_value) {
  switch(datasource_value) {
    case "none":
      return ""
    default:
      return "article-panel-margin-bottom-normal"
  }
}

function ArticlePanelOptionsToClasses(blok) {
  let classes = []

  classes.push(MarginTopDatasourceToClassName(blok.margin_top))
  classes.push(MarginBottomDatasourceToClassName(blok.margin_bottom))

  return classes.join(" ")
}

export { ArticlePanelOptionsToClasses }